<template>
    <div id="app">
        <transition name="fade-transform" mode="out-in">
            <router-view></router-view>
        </transition>
        <div id="login-box-mount-point" style="display: none;"></div>
    </div>
</template>

<script>
export default {
    name: "App",

    mounted() {
        document.title = '中国商业企业管理协会'; 

    },
};
</script>

<style>
html,
body {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
}

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    width: 100vw;
    /* overflow: hidden; */
}

#app * {
    box-sizing: border-box;
}

.fade-transform-leave-active,
.fade-transform-enter-active {
    transition: all 1s;
}


.fade-transform-enter {
    opacity: 0;
    transform: translateX(-30px);
}

.fade-transform-leave-to {
    opacity: 0;
    transform: translateX(30px);
}

::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

::-webkit-scrollbar-track {
    background-color: rgba(53, 96, 171, 0.2); 
    border-radius: 5px;
}

/* 滚动条拖动拇指 */
::-webkit-scrollbar-thumb {
    background-color: #3560ab;
    border-radius: 5px;
    transition: background-color 0.3s ease;
}

/* 当鼠标悬停在滚动条上时改变拇指颜色 */
::-webkit-scrollbar-thumb:hover {
    background-color: darken(#3560ab, 10%);
}

/* 对于水平滚动条 */
::-webkit-scrollbar-horizontal {
    height: 10px;
    /* 水平滚动条的高度 */
}

/* 确保Firefox等其他浏览器也有基本的自定义 */
scrollbar-width: thin;
/* Firefox */
scrollbar-color: #3560ab transparent;
/* Firefox */
</style>
